import React, { useState } from "react";
import "./styles/DashboardView.css";
import { updateCategory } from "../../endpoints/FlashCards/functions";
import { Button, IconButton, PopoverPaper } from "@mui/material";
import { CloseRounded, MoreVertRounded, Style } from "@mui/icons-material";
import DeckCard from "./DeckCard";
import Title from "../Custom/Title";
import { Link, useNavigate } from "react-router-dom";
import CategoryLoader from "./SkeletonLoaders/CategoryLoader";
import NoItemsDisplay from "../Custom/NoItemsDisplay";
const DashboardView = (props) => {
  const navigate = useNavigate();

  const [editableItemId, setEditableItemId] = useState(null);

  async function handleUpdateCategory(id, newName) {
    try {
      await updateCategory(id, props.token, newName);
      await props.getCategories();
    } catch (error) {
      console.log("Error occured at handleUpdateCategory", error);
    }
  }

  function playCategory(categoryName) {
    const params = new URLSearchParams(window.location.search);
    params.set("category", categoryName);
    params.set("shuffle", "true");

    const url = `/flashcards/play?${params.toString()}`;
    navigate(url);
  }
  const CardSection = ({ items, category, categoryIndex }) => {
    const [showCatMenu, setShowCatMenu] = useState(false);
    return (
      <div
        className="position-relative my-5"
        onMouseLeave={(e) => setTimeout(() => setShowCatMenu(false), 500)}
      >
        <h2 className="text-start d-flex justify-content-between gap-2 align-items-center">
          <Title
            id={category.id}
            text={category.name}
            onEdit={handleUpdateCategory}
            isEditing={editableItemId === category.id}
            setEditableItemId={setEditableItemId}
          ></Title>
          <IconButton onClick={() => setShowCatMenu(!showCatMenu)}>
            {showCatMenu ? <CloseRounded /> : <MoreVertRounded />}
          </IconButton>
        </h2>
        <PopoverPaper
          square="false"
          sx={{
            position: "absolute",
            top: 45,
            right: 30,
            boxShadow: "var(--box-shadow)",
            borderRadius: "var(--borderRadius)",
            zIndex: 10001,
          }}
          className="popover-menu"
          hidden={!showCatMenu}
          open={showCatMenu}
          onClose={(e) => setShowCatMenu(false)}
          onMouseLeave={(e) => setTimeout(() => setShowCatMenu(false), 500)}
        >
          <ul className="menu">
            <li>
              <button
                className="menu-link"
                onClick={() => playCategory(category.name)}
                disabled={category.flashcard_count === 0}
              >
                Play Category
              </button>
            </li>
            <li>
              <div
                className="menu-link"
                onClick={() => {
                  setEditableItemId(category.id);
                  setTimeout(() => setShowCatMenu(false), 500);
                }}
              >
                Edit Category
              </div>
            </li>
            <li>
              <Link
                className="menu-link button-link"
                to="/flashcards/deck/new"
                state={{ category: category.id }}
              >
                Add Deck
              </Link>
            </li>
            <li className="no-border p-0">
              <Button
                color="ghostRed"
                variant="contained"
                className="px-4 py-2"
                sx={{
                  borderRadius: "0 0 var(--borderRadius) var(--borderRadius)",
                }}
                onClick={(e) => {
                  props.setDeleteCat(category);
                  setTimeout(() => setShowCatMenu(false), 500);
                }}
              >
                Delete Category
              </Button>
            </li>
          </ul>
        </PopoverPaper>
        <div className="category-decks">
          {!items.length && (
            <div id="no-items">
              <h6 className="mb-0 no-cap">Add a deck to begin studying</h6>
            </div>
          )}
          {items &&
            items.map((item) => (
              <DeckCard
                categoryIndex={categoryIndex}
                key={`category-${category.id}-deck-${item.id}`}
                item={item}
                category={category}
                filter={props.filter}
                setFilter={props.setFilter}
              />
            ))}
        </div>
      </div>
    );
  };

  if (props.loading) {
    return <CategoryLoader count={2} />;
  }

  if (!props.categories?.length) {
    return (
      <NoItemsDisplay
        children={
          <Style
            color="iconGray"
            className="no-items-icon"
            sx={{ transform: "rotate(90deg)" }}
          />
        }
        textItems={[
          "You have not created any categories yet.",
          "Click the add category button to get started.",
        ]}
      />
    );
  }
  return (
    props.categories &&
    props.categories?.map((category, index) => {
      return (
        <CardSection
          categoryIndex={index}
          key={`category-display-${category.id}`}
          items={category.decks}
          category={category}
        />
      );
    })
  );
};

export default DashboardView;
